<div class="certificationContainer">
    <div class="certificationPicture">

    </div>
    <div class="certificationType">
        <p>
            <strong>{{ translatedCertificationType }}</strong>
        </p>
    </div>
</div>